const ITEMS = [
    "Cuidado Humanizado",
    "Gerontologia em Curitiba",
    "Autora do livro Cuidados que Transformam",
    "Terapia Ocupacional",
    "Saúde Mental do Idoso",
    "Atendimento Domiciliar",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-serif text-lg italic text-plum/80 sm:text-xl">{item}</span>
                <svg width="14" height="14" viewBox="0 0 14 14" className="shrink-0 text-lilac" aria-hidden="true">
                    <path d="M7 0 C 8 4, 10 6, 14 7 C 10 8, 8 10, 7 14 C 6 10, 4 8, 0 7 C 4 6, 6 4, 7 0 Z" fill="currentColor" />
                </svg>
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <div className="relative overflow-hidden border-y border-lav bg-white/60 py-5 backdrop-blur-sm" data-testid="editorial-marquee" aria-hidden="true">
        <div className="flex w-max animate-marquee">
            <Row />
            <Row />
        </div>
    </div>
);

export default Marquee;
